<template>
  <form-autocomplete :label="label"
                     :data="search"
                     v-model="val"
                     :disabled="disabled"
                     @select="select"
                     :selected="selected">
  </form-autocomplete>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: {
        label: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        value: null,
        initials: {
            type: null,
            default: null
        },
        scopeAll: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
      return {
        val: false,
        extractedLabel: this.label || this.$t('interface.chooseEmployee')
      }
    },
    methods: {
      search(q) {
        return new Promise((resolve, reject) => {
          this.$store.dispatch(
            'Employees/search',
            {
              q,
              scope: this.isWorkflowController || this.scopeAll
            }
          ).then(data => {
            resolve(data.map((employee) => {
              return {key: employee.id, value: `${employee.last_name} ${employee.name}`}
            }))
          }).catch(error => reject(error))
        })
      },
      select(item) {
        this.$emit('update:initials', item ? item.value : null)
      }
    },
    computed: {
      ...mapGetters('Account', ['isWorkflowController']),
      selected() {
        if (this.value && this.initials) {
          return {
            key: this.value,
            value: this.initials
          }
        } else return false
      }
    },
    watch: {
      val(value) {
        this.$emit('input', value)
      },
      value(value) {
        this.val = value
      }
    }
  }
</script>
